const { postMetaConverter } = require('@shared/services/meta');

export function trackEvent({
  eventName = 'reservaHotels',
  eventProps = {},
  user = null,
}) {
  const defaultProps = {
    category: 'formulario',
    action: 'submit',
    label: 'confirmar',
  };

  const finalProps = { ...defaultProps, ...eventProps };

  // Enviar al dataLayer si existe
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      eventProps: finalProps,
    });
  }

  // Enviar a postMetaConverter si hay usuario
  if (user) {
    postMetaConverter(
      {
        event_name: eventName,
        custom_data: finalProps,
      },
      user
    );
  }
}

export function buildTrackingData({
  metodo_pago = 'tarjeta',
  error = null,
  subsidiary,
  search,
  pricesDetail,
  hotelDetails,
  passenger_email,
  checkIn,
}) {
  const alojamiento_importe =
    typeof pricesDetail === 'number'
      ? pricesDetail
      : pricesDetail?.finalPrice || pricesDetail?.totalValue;

  return {
    ...(error && { error }),
    metodo_pago,
    franquicia: subsidiary,
    alojamiento_ciudad: search?.city?.label,
    alojamiento_estadia: search?.totalNights,
    alojamiento_total_pasajeros: search?.totalPassengers,
    alojamiento_importe,
    alojamiento_nombre: hotelDetails?.name,
    email_pasajero: passenger_email,
    alojamiento_compra_checkIn: checkIn,
  };
}
